/**
 * Shared loading state component for popup pages
 */
import React from 'react';
import { LoadingSpinner } from '@ais-ui/ui-core';

interface PopupLoadingStateProps {
  message?: string;
}

export const PopupLoadingState: React.FC<PopupLoadingStateProps> = ({
  message = 'Loading data...',
}) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-background">
      <LoadingSpinner className="h-8 w-8" />
      <p className="mt-4 text-muted-foreground">{message}</p>
    </div>
  );
};
